import { httpClient } from "./httpClient";


const Requests = (_httpClient) =>({
    newcompany: (data) => _httpClient.post("newcompany", data),
    companies: () => _httpClient.get("companies"),
    customers: () => _httpClient.get("customers"),
    consultion: (data) => _httpClient.post("consultation", data),
    calculation: (data) => _httpClient.get("calculation",data)
})

export const requests = Requests(httpClient);